import { useMembersNativeBack } from '../lib/useMembersConversationOverlay'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MemberFrontDeskModal from '../components/MemberFrontDeskModal'
import { frontDeskReturnLocation } from '../lib/frontDeskReturn'

export default function MemberContactFrontDeskPage({ clubCode }) {
  const navigate = useNavigate()
  const location = useLocation()
  const returnTo = frontDeskReturnLocation(
    location.state?.membersFrom || location.state?.returnTo || new URLSearchParams(location.search).get('returnTo'),
    clubCode,
  )
  useMembersNativeBack(true, () => navigate(returnTo, { replace: true }))
  return <MemberFrontDeskModal clubCode={clubCode} onClose={() => navigate(returnTo, { replace: true })} />
}
